import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/gruh-udhyog/franchise-enquiries";

export const Route = createFileRoute(
  "/admin/_modules/_gruh-udhyog/franchise-enquiries"
)({
  component: Page,
});
